import { EmptyState, Loading, MaterialIcon, StyledButton } from '@gorila-shared-ui/components';
import AutoSizer from 'react-virtualized-auto-sizer';
import { VariableSizeList as List } from 'react-window';
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import useEffectOnce from '../../hooks/useEffectOnce';
import { useStyles } from '../../hooks/useStyles';
import { journeyIdsState, loadingJourneysState, selectedJourneyIdState } from '../../storage/journeys';
import { FloatingCardContent } from '../layout/cards/FloatingCardContent';
import JourneyCard from './JourneyCard';
import JourneyFilters from './JourneyFilters';

export function JourneyList() {
  const { theme } = useStyles();
  const journeyIds = useRecoilValue(journeyIdsState);
  const setSelectedJourneyId = useSetRecoilState(selectedJourneyIdState);
  const resetSelectedJourneyId = useResetRecoilState(selectedJourneyIdState);
  const loadingJourneys = useRecoilValue(loadingJourneysState);

  useEffectOnce(() => {
    return () => {
      resetSelectedJourneyId();
    };
  });

  const onNewJourney = () => {
    setSelectedJourneyId('');
  };

  return (
    <FloatingCardContent
      flexible
      gap={theme.sizing.scale600}
    >
      {!journeyIds && !loadingJourneys && <EmptyState title="Todavía no creas ningun trayecto" />}
      {!journeyIds && loadingJourneys && <Loading />}
      {journeyIds && (
        <>
          <JourneyFilters />
          {!!journeyIds?.length && (
            <div style={{ flex: 1 }}>
              <AutoSizer>
                {({ width, height }) => (
                  <List
                    height={height ? height : 500}
                    itemCount={journeyIds.length}
                    itemSize={() => 178}
                    width={width ? width : 200}
                    itemData={journeyIds}
                  >
                    {JourneyCard}
                  </List>
                )}
              </AutoSizer>
            </div>
          )}
          {!journeyIds.length && (
            <EmptyState
              title="No se encontraron resultados"
              description="Intenta con otra busqueda"
            />
          )}
        </>
      )}
      {(journeyIds || !loadingJourneys) && (
        <StyledButton
          size="compact"
          shape="square"
          onClick={onNewJourney}
          startEnhancer={<MaterialIcon name={'add'} />}
          kind="tertiary"
        >
          Nuevo trayecto
        </StyledButton>
      )}
    </FloatingCardContent>
  );
}
